import { render } from "./PackageListPage.vue?vue&type=template&id=95b05300&ts=true"
import script from "./PackageListPage.vue?vue&type=script&lang=ts"
export * from "./PackageListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__